var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconhelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_5515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FFCA3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 12.0971C23.9475 18.6474 18.6474 23.9475 12.0971 23.9995L6.32674 18.2292C4.63596 16.688 3.57471 14.468 3.57471 12C3.57471 7.34674 7.34674 3.57471 12 3.57471C14.468 3.57471 16.688 4.63596 18.2292 6.32674L23.9995 12.0971Z",
    fill: "#FF9500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20.4253C16.6532 20.4253 20.4253 16.6532 20.4253 12C20.4253 7.34685 16.6532 3.57471 12 3.57471C7.34685 3.57471 3.57471 7.34685 3.57471 12C3.57471 16.6532 7.34685 20.4253 12 20.4253Z",
    fill: "#009AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4254 11.9999C20.4254 16.6533 16.6534 20.4253 12 20.4253V3.57458C16.6534 3.57458 20.4254 7.34657 20.4254 11.9999Z",
    fill: "#0074C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.531 10.2759H10.4691V17.6015H13.531V10.2759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5309 10.2755H12V17.6016H13.5309V10.2755Z",
    fill: "#E0E0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.36374C12.882 9.36374 13.597 8.64873 13.597 7.76671C13.597 6.88469 12.882 6.16968 12 6.16968C11.118 6.16968 10.403 6.88469 10.403 7.76671C10.403 8.64873 11.118 9.36374 12 9.36374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.597 7.76673C13.597 8.64892 12.8822 9.36376 12 9.36376V6.17017C12.8822 6.17017 13.597 6.88501 13.597 7.76673Z",
    fill: "#E0E0E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_5515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconhelp);
export default __webpack_public_path__ + "static/media/iconhelp.bcf9d7035ac9297f793481dd6a4f2380.svg";
export { ForwardRef as ReactComponent };